import get from 'lodash/get';
import set from 'lodash/set';

import config, { getConfigWithContext, setEnabled } from 'Config';
import { getContextByName } from 'Lib/globalContext';
import { avifSupported, webpSupported } from 'Lib/utils/imageTypeSupport';
import isInStandaloneMode from 'Lib/utils/isInStandaloneMode';

import { STORE_CONTEXT } from 'Store/constants';

const getDehydratedState = () => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { __data, __intlData } = window;

  const state = {
    ...__data,
    ...__intlData,
  };

  // service worker `fetch` will not send correct Accept header
  // https://github.com/w3c/ServiceWorker/issues/945
  // hence doing a client side detect as a fallback solution until we have other solution
  if (!getContextByName('webp')) {
    set(state, [STORE_CONTEXT, 'webp'], webpSupported);
    setEnabled('webp', !!webpSupported);

    // set config object with dehydrated context
    // this is just to update the global config object
    getConfigWithContext(state.context);
  }

  if (!getContextByName('avif')) {
    set(state, [STORE_CONTEXT, 'webp'], avifSupported);
    setEnabled('avif', !!avifSupported);

    // set config object with dehydrated context
    // this is just to update the global config object
    getConfigWithContext(state.context);
  }

  if (!getContextByName('lite')) {
    const liteConfig = config.lite;
    const isLite =
      get(document, ['referrer'], '').startsWith(liteConfig.referrer) ||
      get(__data, [STORE_CONTEXT, 'queryParams', 'lite']);

    set(state, [STORE_CONTEXT, 'lite'], isLite ? 1 : 0);
    // set config object with dehydrated context
    // this is just to update the global config object

    getConfigWithContext(state.context);
  }

  // detect standalone
  if (!getContextByName('standalone')) {
    set(state, [STORE_CONTEXT, 'standalone'], isInStandaloneMode);
    setEnabled('liteHomepage', !!isInStandaloneMode);

    getConfigWithContext(state.context);
  }

  return state;
};

export default getDehydratedState;
